export default __webpack_public_path__ + "static/media/1024TMBG.98fc104c.jpg";